import { render, staticRenderFns } from "./VCompanyDocuments.vue?vue&type=template&id=336fd898&lang=pug"
import script from "./VCompanyDocuments.vue?vue&type=script&lang=ts"
export * from "./VCompanyDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports